<template>
  <v-row justify="center">
    <v-dialog :value="dialog" max-width="400" persistent @input="close">
      <v-card>
        <DialogCardTitle :title="title" @close="close" />

        <v-card-text class="py-5 d-flex justify-center">
          <span v-if="text">{{ text }}</span>
          <slot v-else name="text" />
        </v-card-text>

        <v-card-actions class="px-6 pt-0 pb-5 d-none d-md-flex justify-center">
          <slot name="action" />
          <v-btn
            color="primary"
            class="px-4 d-flex align-center"
            @click="close"
          >
            <span class="btn-text">Понятно</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import DialogCardTitle from '@/ui/dialog/DialogCardTitle'

export default {
  components: { DialogCardTitle },

  props: {
    dialog: Boolean,
    title: {
      type: String,
      default: 'Предупреждение',
    },
    text: {
      type: String,
      default: '',
    },
  },

  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>
